import './LegalBody.styles.scss';
import { LegalBodyProps } from '../Legal.types';
const BlockContent = require('@sanity/block-content-to-react');

export const serializers = {
  types: {
    code: (props: any) => (
      <pre data-language={props.node.language}>
        <code>{props.node.code}</code>
      </pre>
    )
  }
};

function LegalBody({ body }: LegalBodyProps) {
  return (
    <div className="legal-body pre-wrap">
      <BlockContent blocks={body} serializers={serializers} />
    </div>
  );
}

export default LegalBody;
